import {useEffect} from "react";
import {useMediaQuery, useTheme} from "@mui/material";
import {applyFloorplanLocate} from "../utils/floorplan-locate";
import {useFloorplanContext} from "./useFloorplanContext";
import {useReadStore} from "./useReadStore";
import {useTimeframe} from "./useTimeframe";

export function useFloorplanLocate() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const {canvas, containerRef} = useFloorplanContext();
    const {setReservationDaySlice} = useTimeframe();
    const locateRequest = useReadStore(state => state.locateRequest);
    const consumeLocateRequest = useReadStore(state => state.consumeLocateRequest);
    const highlightTable = useReadStore(state => state.highlightTable);

    useEffect(() => {
        const container = containerRef.current;
        if (!locateRequest || !canvas || !container) return;

        const request = consumeLocateRequest();
        if (!request) return;

        applyFloorplanLocate({
            request,
            canvas,
            container,
            isMobile,
            selectTimeframe: range => setReservationDaySlice("custom", range),
            highlightTables: highlightTable,
        });
    }, [
        canvas,
        consumeLocateRequest,
        containerRef,
        highlightTable,
        isMobile,
        locateRequest,
        setReservationDaySlice,
    ]);
}
